import { Helmet } from 'react-helmet-async'
import { useBranding } from '@/hooks/useBranding'

export const DynamicHead: React.FC = () => {
    const {
        description,
        ogTitle,
        ogDescription,
        twitterTitle,
        twitterDescription,
        canonicalUrl,
        ogUrl,
        ogSiteName,
        appleMobileWebAppTitle,
        author,
        favicon
    } = useBranding()

    return (
        <Helmet>
            {/* Basic meta tags - title is handled by individual page SEOHead components */}
            <meta name="description" content={description} />
            <meta name="author" content={author} />

            {/* Canonical and alternate links */}
            <link rel="canonical" href={canonicalUrl} />
            <link rel="alternate" hrefLang="nl" href="https://spellen.land/" />
            <link rel="alternate" hrefLang="en" href="https://spellen.land/en/" />
            <link rel="alternate" hrefLang="x-default" href="https://spellen.land/" />

            {/* Favicon */}
            <link rel="icon" type="image/x-icon" href={favicon.ico} />
            <link rel="icon" type="image/png" sizes="32x32" href={favicon.png32} />
            <link rel="icon" type="image/png" sizes="512x512" href={favicon.png512} />
            <link rel="apple-touch-icon" href={favicon.appleTouchIcon} />

            {/* OpenGraph meta tags */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={ogTitle} />
            <meta property="og:description" content={ogDescription} />
            <meta property="og:url" content={ogUrl} />
            <meta property="og:site_name" content={ogSiteName} />

            {/* Twitter Card meta tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={twitterTitle} />
            <meta name="twitter:description" content={twitterDescription} />

            {/* iOS specific meta tags */}
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-status-bar-style" content="default" />
            <meta name="apple-mobile-web-app-title" content={appleMobileWebAppTitle} />
        </Helmet>
    )
} 